<template>
  <div>

    <v-container v-if="reloadPage">
      <v-row class="mt-0 pt-0 mb-0 pb-0" v-if="center!=null">
        <l-map v-if="swipeDirection!='Up'" ref="map" :zoomControl="true" :zoom="zoom" :center="center"
          :options="mapOptions"
          style="height:70vhvh;z-index: 2;position:absolute;bottom:0px;left: 0;overflow-y: hidden;">

          <l-tile-layer :url="url" :opacity=" 0.8 " />

          <l-polyline v-for="(item,i) in connectionLine" :key="i+item.latlngs" :dashArray="item.dasharray"
            :lat-lngs="item.latlngs" :color="item.color"></l-polyline>

          <l-marker @click="openDialogDetailHeritage(item)" v-for="(item,i) in connectedHeritages" :zIndexOffset="100"
            :lat-lng="{lat:item.latitude,lng:item.longitude}" :key="i+item.latitude+item.longitude">
            <l-icon :iconSize="[40, 40]" :iconAnchor="[20, 20]">
              <div>

                <img v-if="item.image!=null" class="KGheritageImage" :src="loadPhoto(item.image)"
                  @error="require('@/assets/placeholder.png')" />
                <img v-else :src="require('@/assets/placeholder.png')" />
              </div>
            </l-icon>
          </l-marker>
          <l-marker v-if="selectedSingleStory" :zIndexOffset="110"
            :lat-lng="{lat:selectedSingleStory.latitude,lng:selectedSingleStory.longitude}" @click="openDialogDetail(selectedSingleStory)" :key="selectedSingleStory.title+selectedSingleStory.id">
            <l-icon :iconSize="[120, 120]" :iconAnchor="[60, 60]">
              <div v-if="selectedSingleStory.cover_image.media.formats">
                <mediaFileStory :isSelectedStory="true" :isMapRoundImg="true"  :isKGimage="true"
                  :isPlaceholder="false" v-if="selectedSingleStory.cover_image.media.formats.coverImageCenter" 
                  :mediaUrl="apiStrapi +'/uploads/'+ selectedSingleStory.cover_image.media.formats.coverImageCenter.hash+selectedSingleStory.cover_image.media.formats.coverImageCenter.ext"
                  :type="selectedSingleStory.cover_image.type" :isLocal="false" :isThumbnail="false" />
                <mediaFileStory :isSelectedStory="true" :isMapRoundImg="true"  :isKGimage="true"
                  :isPlaceholder="false" v-else-if="selectedSingleStory.cover_image.media.formats.small"
                  :mediaUrl=" apiStrapi +'/uploads/'+ selectedSingleStory.cover_image.media.formats.small.hash+selectedSingleStory.cover_image.media.formats.small.ext"
                  :type="selectedSingleStory.cover_image.type" :isLocal="false" :isThumbnail="false" />
                <mediaFileStory :isSelectedStory="true" :isMapRoundImg="true"  :isKGimage="true"
                  :isPlaceholder="false" v-else-if="selectedSingleStory.cover_image.media.formats.thumbnail" 
                  :mediaUrl="apiStrapi +'/uploads/'+ selectedSingleStory.cover_image.media.formats.thumbnail.hash+selectedSingleStory.cover_image.media.formats.thumbnail.ext"
                  :type="selectedSingleStory.cover_image.type" :isLocal="false" :isThumbnail="false" />
                <v-img v-else :src="require('@/assets/placeholder.png')"></v-img>
              </div>
            </l-icon>
          </l-marker>
          <l-marker v-for="item in connectedStory" :zIndexOffset="99"
            :lat-lng="{lat:item.latitude,lng:item.longitude}" @click="openDialogDetail(item)" :key="item.title+item.id">
            <l-icon :iconSize="[80, 80]" :iconAnchor="[40, 40]">
              <div v-if="item.cover_image.media.formats">
                <mediaFileStory :isMapRoundImg="true"  :isKGimage="true"
                  :isPlaceholder="false" v-if="item.cover_image.media.formats.coverImageCenter" class="coverImageStyle"
                  :mediaUrl="apiStrapi +'/uploads/'+ item.cover_image.media.formats.coverImageCenter.hash+item.cover_image.media.formats.coverImageCenter.ext"
                  :type="item.cover_image.type" :isLocal="false" :isThumbnail="false" />
                <mediaFileStory :isMapRoundImg="true" :isKGimage="true"
                  :isPlaceholder="false" v-else-if="item.cover_image.media.formats.small" class="coverImageStyle"
                  :mediaUrl=" apiStrapi +'/uploads/'+ item.cover_image.media.formats.small.hash+item.cover_image.media.formats.small.ext"
                  :type="item.cover_image.type" :isLocal="false" :isThumbnail="false" />
                <mediaFileStory :isMapRoundImg="true"  :isKGimage="true"
                  :isPlaceholder="false" v-else-if="item.cover_image.media.formats.thumbnail" class="coverImageStyle"
                  :mediaUrl="apiStrapi +'/uploads/'+ item.cover_image.media.formats.thumbnail.hash+item.cover_image.media.formats.thumbnail.ext"
                  :type="item.cover_image.type" :isLocal="false" :isThumbnail="false" />
                <v-img v-else :src="require('@/assets/placeholder.png')"></v-img>
              </div>
            </l-icon>
          </l-marker>
          <l-control style="z-index:3" position="topright" class="mt-15 mr-0">
            <img style="width:100px;" @click="goBack()" :src="require('@/assets/colorconnectedness.png')" />
          </l-control>
        </l-map>
      </v-row>

    </v-container>
    <div class="wrapper">
      <v-footer v-if="swipeDirection!='Up'" fixed v-touch="{
      left: () => swipe('Left'),
      right: () => swipe('Right'),
      up: () => swipe('Up'),
      down: () => swipe('Down')
    }" style="height: 12vh;background-color:#eee;justify-content: center;padding-top:0%;">

        <v-tooltip color="primaryVariant" v-model="isTooltipOpen" top>

          <div>

            {{$t('SeeStoryConnectedness')}}</div>
          <template v-slot:activator="{ on, attrs }">
            <v-container class="mt-0 mb-0 mx-0 pt-0 pb-0 px-0">
              <v-row class="pt-0 mt-0 mb-0 pb-0" align=center>
                <v-col class="pt-1 mt-1 mb-1 pb-1" cols=5>
                </v-col>
                <v-col class="pt-1 mt-1 mb-1 pb-1" cols=2>
                  <hr />
                </v-col>
                <v-col class="pt-1 mt-1 mb-1 pb-1" cols=5>
                </v-col>
              </v-row>
              <v-row class="pt-0 mt-0 mb-0 pb-0" align=center>
                <v-col class="pt-0 mt-0 mb-0 pb-0" cols=8 align=center>
                  <div v-bind="attrs" v-on="on">
                    {{$t('SeeStoryConnectedness')}}</div>
                  <span>{{$t('swipeUpToSeeMoreDetail')}}</span>
                </v-col>
                <v-col class="pt-0 mt-0 mb-0 pb-0" cols=4 align=left>
                  <v-row align="center" class="pt-0 mt-0 mb-0 pb-0">
                    <v-col align="center" class="labelConnections pt-0 mt-0 mb-0 pb-0" cols=6>
                      <hr class="solidDarkGreen" />

                    </v-col>
                    <v-col align="left" class="labelConnections pt-0 mt-0 mb-0 pb-0" cols=6>
                      {{$t('connectedStories')}}
                    </v-col>
                    <!--v-col class="labelConnections pt-0 mt-2 mb-2 pb-0" cols=12>
                    </v-col-->
                    <v-col align="center" class="labelConnections pt-0 mt-2 mb-0 pb-0" cols=6>
                      <hr class="dashedLightGreen" />
                    </v-col>
                    <v-col align="left" class="labelConnections pt-0 mt-0 mb-0 pb-0" cols=6>
                      {{$t('connectedHeritages')}}

                    </v-col>
                  </v-row>

                </v-col>
              </v-row>
            </v-container>
          </template>

        </v-tooltip>

      </v-footer>
      <div class="background:black" v-else v-touch="{
      left: () => swipe('Left'),
      right: () => swipe('Right'),
      up: () => swipe('Up'),
      down: () => swipe('Down')
    }">

        <v-card class="px-5 pt-15 mt-5">
          <h4 class="pt-0">{{$t('SeeStoryConnectedness')}} </h4>

          <v-container>
            <v-row class="mb-1" align="center" justify="center" style="background-color:#EEE;">
              <v-col align="center" cols=2>
                {{connectedStory.length}}
              </v-col>
              <v-col cols=10 style="border-left:0.5rem solid white">
                <span>
                  {{$t('storyConnectOtherStories',[connectedStory.length])}}
                </span>
              </v-col>
            </v-row>
            <v-row align="center" justify="center" style="background-color:#EEE;">
              <v-col class="mx-0 mt-0 mb-0" align="center" cols=2>
                {{connectedHeritages.length}}
              </v-col>
              <v-col cols=10 style="border-left:0.5rem solid white">
                <span>
                  {{$t('storyConnectOtherculturalHeritage',[connectedHeritages.length])}}
                </span>
              </v-col>
            </v-row>
            <v-row v-if="storyTags.length>0">
              <v-col cols=10>
                <span class="font-weight-bold">{{$t('storyKeywords')}}</span>
              </v-col>
              <v-col cols="12">
                <span v-for="(element,index) in storyTags" :key="element.id+index">
                  <v-chip class="mr-2 mb-1">{{$t(element.tag)}}</v-chip>
                </span>
              </v-col>
            </v-row>
          </v-container>

          <v-sheet class="mx-auto" elevation="8" max-width="800">
            <h3 class="ml-4">{{$t('connectedStories')}}</h3>
            <v-slide-group class="pa-4" active-class="success">
              <v-slide-item v-for="singlestory in connectedStory" :key="singlestory.id">
                <v-card class="mx-5 maxwidth">
                  <v-container>
                    <v-row align="center" justify="center">
                      <v-col cols="12">
                        <mediaFileStory :isKGimage="true" :isPlaceholder="false"
                          v-if="singlestory.cover_image.media.formats.coverImageCenter"
                          :mediaUrl="apiStrapi +'/uploads/'+ singlestory.cover_image.media.formats.coverImageCenter.hash + singlestory.cover_image.media.formats.coverImageCenter.ext"
                          :type="singlestory.cover_image.type" :isLocal="false" :isThumbnail="false" />
                        <mediaFileStory :isKGimage="true" :isPlaceholder="false"
                          v-else-if="singlestory.cover_image.media.formats.small"
                          :mediaUrl="apiStrapi +'/uploads/'+ singlestory.cover_image.media.formats.small.hash + singlestory.cover_image.media.formats.small.ext"
                          :type="singlestory.cover_image.type" :isLocal="false" :isThumbnail="false" />
                        <mediaFileStory :isKGimage="true" :isPlaceholder="false" v-else
                          :mediaUrl="apiStrapi +'/uploads/'+ singlestory.cover_image.media.formats.thumbnail.hash + singlestory.cover_image.media.formats.thumbnail.ext"
                          :type="singlestory.cover_image.type" :isLocal="false" :isThumbnail="false" />
                        <h4>{{singlestory.title}}</h4>
                        <p v-html="singlestory.shortDescription"></p>
                      </v-col>
                    </v-row>
                    <v-row align="center" justify="center">
                      <v-col cols="12">
                        <v-btn text @click="goToStoryDetail(parseInt(singlestory.id))">{{$t('readMore')}}</v-btn>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card>
              </v-slide-item>
            </v-slide-group>
          </v-sheet>


          <v-sheet v-if="connectedHeritages.length>0" class="mx-auto" elevation="8" max-width="800">
            <h3 class="ml-4">{{$t('connectedHeritages')}}</h3>
            <v-slide-group class="pa-4" active-class="success">
              <v-slide-item v-for="singlestory in connectedHeritages" :key="singlestory.wid">
                <v-card class="mx-5 maxwidth">
                  <v-container>
                    <v-row align="center" justify="center">
                      <v-col cols="12">
                        <v-img v-if="singlestory.image!=null&&typeof singlestory.image=='string'"
                          :src="singlestory.image" />
                        <v-img v-else-if="singlestory.image!=null&&typeof singlestory.image=='array'"
                          :src="singlestory.image[0]" />
                        <v-img v-else
                          :src="'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTpWevd8jXp4O67ox0vPsvsiQGfM4QQGO_xHhBd_ZV4MkrS9hsiVrBIsdtSpUCtBQw-eQo&usqp=CAU'" />

                        <h4>{{singlestory.label}}</h4>
                        <span :html="singlestory.image"></span>
                        <p v-html="singlestory.description"></p>
                        <a target="_blank"
                          :href="'https://www.wikidata.org/wiki/'+ singlestory.wid">{{$t('goToWikidata')}}</a>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card>
              </v-slide-item>
            </v-slide-group>
          </v-sheet>
        </v-card>
      </div>
    </div>

    <div class="text-center">
      <v-dialog v-model="isDetailHeritageOpen" width="500">
        <v-card style="padding:2%">
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-icon @click="closeIsDetailHeritageOpen">mdi-close</v-icon>
          </v-card-actions>
          <v-img :src="detailModalHeritage.image" />
          <v-card-text>
            <h3>{{detailModalHeritage.title}}</h3>
            <p>
              {{detailModalHeritage.shortDescription}}
            </p>
          </v-card-text>

          <v-divider></v-divider>
          <v-card-actions>
            <v-btn text style="border:2px solid;border-radius:99rem" color=primary><a target="_blank"
                :href="'https://www.wikidata.org/wiki/'+ detailModalHeritage.ID">{{$t('goToWikidata')}}</a></v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

    <div class="text-center">
      <v-dialog v-model="isDetailOpen" width="500" px-2 pt-2 pb-2>
        <v-card>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-icon large color="primary" @click="closeIsDetailOpen()">mdi-close</v-icon>
          </v-card-actions>
          <template v-if="detailModal.image.media">
            <mediaFileStory :isKGimage="true" :isPlaceholder="false" style="margin:auto;width:90%;ratio:1"
              v-if="detailModal.image.media.formats.coverImageCenter" class="coverImageStyle"
              :mediaUrl="apiStrapi +'/uploads/'+ detailModal.image.media.formats.coverImageCenter.hash + detailModal.image.media.formats.coverImageCenter.ext"
              :type="detailModal.image.type" :isLocal="false" :isThumbnail="false" />
            <mediaFileStory :isKGimage="true" :isPlaceholder="false" style="margin:auto;width:90%;ratio:1"
              v-else-if="detailModal.image.media.formats.small" class="coverImageStyle"
              :mediaUrl="apiStrapi +'/uploads/'+ detailModal.image.media.formats.small.hash + detailModal.image.media.formats.small.ext"
              :type="detailModal.image.type" :isLocal="false" :isThumbnail="false" />
            <mediaFileStory :isKGimage="true" :isPlaceholder="false" style="margin:auto;width:90%;ratio:1"
              v-else-if="detailModal.image.media.formats.thumbnail" class="coverImageStyle"
              :mediaUrl="apiStrapi +'/uploads/'+ detailModal.image.media.formats.thumbnail.hash + detailModal.image.media.formats.thumbnail.ext"
              :type="detailModal.image.type" :isLocal="false" :isThumbnail="false" />
          </template>
          <v-card-text>
            <h3>{{detailModal.title}}</h3>

            <p class="pb-2">{{detailModal.shortDescription}}</p>
            <p>
              <strong>{{$t('similarities')}}:</strong><span class="mr-1 ml-1" v-for="item in detailModal.similarities"
                :key="item">{{$t(item.tag)}}</span>
            </p>

          </v-card-text>
          <v-card-actions>
            <v-container>
              <v-row align="center">
                <v-col align="center" cols=6>
                  <v-btn style="border:2px solid;border-radius:99rem" color=primary text
                    @click="goToStoryDetail(parseInt(detailModal.storyID))">{{$t('readMore')}}
                  </v-btn>
                </v-col>
                <v-col align="center" cols=6>
                  <deepLinkButton :isKGVisualization="true" />
                </v-col>
              </v-row>
            </v-container>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>


  </div>

</template>

<script>
import mediaFileStory from "@/components/mediaFileStory.vue";
import deepLinkButton from "@/components/deepLinkButton.vue";

import {
  Touch
} from "vuetify/lib/directives"

import dialogMixin from "vue-dialog-mixin"
import 'leaflet/dist/leaflet.css';
import {
  latLng
} from "leaflet";
import {
  LMap,
  LPolyline,
  LTileLayer,
  LMarker,
  LIcon,
  LControl
} from "vue2-leaflet";
export default {
  name: "singleStoryKGView",
  mixins: [dialogMixin],
  data() {
    return {
      onlyHeritagePositionsForLines: [],
      reloadPage: false,
      onlyStoriesPositionsForLines: [],
      onlyHeritagesPositionsForLinesHeritage: [],
      apiStrapi: process.env.VUE_APP_ROOT_STRAPI,
      isTooltipOpen: true,
      currentArrayOfStories: [],
      swipeDirection: 'None',
      model: null,
      isDetailOpen: false,
      isDetailHeritageOpen: false,
      detailModal: {
        storyID: null,
        title: '',
        image: '',
        shortDescription: "",
        similarities: []
      },
      detailModalHeritage: {
        id: null,
        title: '',
        image: '',
        shortDescription: "",
        similarities: []
      },
      //detailModal:{storyID:123 ,title:'Title',image:'https://upload.wikimedia.org/wikipedia/commons/thumb/f/f8/Milano%2C_Duomo%2C_2016-06_CN-04.jpg/1024px-Milano%2C_Duomo%2C_2016-06_CN-04.jpg',shortDescription:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",similarities:["keyword 1","keyword 2","keyword 3","keyword 4","keyword 5"]},
      //detailModalHeritage:{id:123 ,title:'Title',image:'https://upload.wikimedia.org/wikipedia/commons/thumb/f/f8/Milano%2C_Duomo%2C_2016-06_CN-04.jpg/1024px-Milano%2C_Duomo%2C_2016-06_CN-04.jpg',shortDescription:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",similarities:["keyword 1","keyword 2","keyword 3","keyword 4","keyword 5"]},

      //placeholder connected story
      connectedStory: [],
      connectedHeritages: [],
      polyline: {},
      connectionLine: [],

      apiUrl: process.env.VUE_APP_ROOT_API,
      getUserCoordinates: null,
      maploaded: false,
      cache: {},
      dialog: false,
      notifications: false,
      sound: true,
      widgets: false,
      staticAnchor: [16, 37],
      zoom: 8,
      center: null, //latLng(44.8377720, 11.6186548),
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      currentZoom: 8,
      showParagraph: false,
      mapOptions: {
        zoomSnap: 0.5,
        zoomControl: true
      },
      showMap: true,
    }
  },
  directives: {
    Touch
  },
  components: {
    deepLinkButton,
    mediaFileStory,
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    LPolyline,
    LControl
  },
  async mounted() {
    this.currentArrayOfStories = this.getCurrentAllPublicStories
    //set the center of the graph in the coordinate of the selected story
    this.center = {
      lat: this.selectedSingleStory.latitude,
      lng: this.selectedSingleStory.longitude
    }

    this.$getLocation()
      .then(response => {
        this.getUserCoordinates = response
        if (this.getUserCoordinates != null) {
          //user coordinates
        }
      }).then(() => {
        this.getSelectStoryHeritageConnections().then(() => {
          this.getSelectStoryConnectionsToStories().then(() => {
            this.getLinesGraph()
          })
        })
      })
    //this.getSelectedSingleStoryShortDescription()
    // close the tooltip after 5 seconds
    await setTimeout(() => {
      this.isTooltipOpen = false
    }, 5000)
  },
  computed: {
    connectedStoryLength: {
      get: function () {
        return this.connectedStoryWithoutSelectedStory.length;
      }
    },
    getCurrentAllPublicStories: {
      get: function () {
        return this.$store.getters.getCurrentAllPublicStories;
      }
    },
    selectedSingleStory: {
      get: function () {
        return this.$store.getters.getSelectedSingleStory;
      }
    },
    storyTags: {
      get: function () {
        return this.$store.getters.getSingleStoryTags;
      }
    }
  },
  methods: {
    closeIsDetailOpen() {
      this.detailModal = {
          storyID: null,
          title: '',
          image: '',
          shortDescription: "",
          similarities: []
        },
        this.isDetailOpen = false
    },
    closeIsDetailHeritageOpen() {
      this.detailModalHeritage = {
          id: null,
          title: '',
          image: '',
          shortDescription: "",
          similarities: []
        },
        this.isDetailHeritageOpen = false
    },
    async getLinesGraph() {
      try {
        this.$store.dispatch('setLoading', true)
        this.connectionLine = []
        // i take the position of the current story from selectedSingleStory
        // calc green line from selected story to HERITAGES
        // calc purple line to connect all HERITAGES
        // calc yellow line from selected story to stories
        this.reloadPage = false
        this.onlyStoriesPositionsForLines.forEach(element =>
          this.connectionLine.push({
            latlngs: [
              latLng(this.selectedSingleStory.latitude, this.selectedSingleStory.longitude),
              latLng(element.lat, element.lng)
            ],
            color: 'black',
            dasharray: 'null'
          }))
        this.onlyHeritagePositionsForLines.forEach(element =>
          this.connectionLine.push({
            latlngs: [
              latLng(this.selectedSingleStory.latitude, this.selectedSingleStory.longitude),
              latLng(element.lat, element.lng)
            ],
            color: '#81B9BF',
            dasharray: '20, 20'
          }))

        this.$store.dispatch('setLoading', false)
        this.reloadPage = true
      } catch (error) {
        console.log(error);
      }
    },
    /* REMOVE MOCK AND CONNECT TO BACKEND*/
    async getSelectStoryHeritageConnections() {
      try {

        this.$store.dispatch('setLoading', true)
        this.connectedHeritages = []
        let completeurl = this.apiUrl + '/getStoryConnections?story_id=' + this.selectedSingleStory.id + '&short=100&latitude=' + this.getUserCoordinates.lat + '&longitude=' + this.getUserCoordinates.lng + '&limit=100'
        let temp
        temp = await this.getaxiosResponse(completeurl)
        temp.data.forEach(element => {
          if (element.label != "" && element.latitude && element.longitude && element.description != "" && element.image != null) {
            this.connectedHeritages.push(element)
          }
        })
        this.connectedHeritages.forEach(element => this.onlyHeritagePositionsForLines.push({
          'lat': element.latitude,
          'lng': element.longitude
        }))
        //push selected story in array of connected stories as first element

        //this.connectedHeritages.shift(this.selectedSingleStory)

        this.connectedHeritages.forEach(element => this.onlyHeritagesPositionsForLinesHeritage.push({
          'lat': element.latitude,
          'lng': element.longitude
        }))
        this.connectedHeritages.forEach((element, index) => {
          if (Array.isArray(element.image)) {

            this.connectedHeritages[index].image = element.image[0]
          }

        })


        this.$store.dispatch('setLoading', false)

      } catch (error) {
        console.log(error);
      }
    },
    loadPhoto(value) {
      let outcome
      try {
        outcome = value.find(",")
      } catch (err) {
        outcome = false
      }
      if (outcome != false) {
        let arrayofImages = value.split(',')
        arrayofImages.forEach(element => {
          console.log(element)
          if (element.indexOf('.jpg')) {
            return element
          }
          return null
        })
      } else
        return value
    },
    async getSelectStoryConnectionsToStories() {
      try {
        this.$store.dispatch('setLoading', true)
        let completeurl = this.apiUrl + '/getSimilarStories?story_id=' + this.selectedSingleStory.id + '&short=100&latitude=' + this.getUserCoordinates.lat + '&longitude=' + this.getUserCoordinates.lng + '&limit=100'
        let temp
        temp = await this.getaxiosResponse(completeurl)
        this.connectedStory = await temp.data
        this.connectedStory.forEach(element => this.onlyStoriesPositionsForLines.push({
          'lat': element.latitude,
          'lng': element.longitude
        }))

        this.$store.dispatch('setLoading', false)
      } catch (error) {
        console.log(error);
      }
    },

    goToStoryDetail(idOfSelectedStory) {
      this.isDetailOpen = false;
      this.getCurrentAllPublicStories.forEach((element, index) => {
        if (element.id == idOfSelectedStory) {
          this.openSingleStoryDetail(index, idOfSelectedStory)
        }
      })
    },
    //function copied from stories preview home
    openSingleStoryDetail: function (indexArrayOfStories, idOfSelectedStory) {
      //console.info("IDOftheStoryDetail",idOfSelectedStory,"array",this.currentArrayOfStories.slice(this.indexArrayOfStories).concat(this.currentArrayOfStories.slice(0,this.indexArrayOfStories)))

      // list of all stories for carousel array currentArrayOfStories
      // current index of array
      this.$store.dispatch('setCurrentListOfStoriesCarousel', this.currentArrayOfStories.slice(indexArrayOfStories).concat(this.currentArrayOfStories.slice(0, indexArrayOfStories))).then(
        this.$store.dispatch('setSelectedSingleStoryID', idOfSelectedStory).then(
        this.$router.push({
                'name': 'carouselForSingleStoryView',query: { idStory: idOfSelectedStory }
              })
        )
        //dispatch story id in the store
      )
    },
    openDialogDetailHeritage(item) {
      this.detailModalHeritage.image = item.image
      this.detailModalHeritage.title = item.label
      this.detailModalHeritage.singleShortDescription = item.description
      this.detailModalHeritage.coordinates = {
        'lat': item.latitude,
        'lng': item.longitude
      }
      this.detailModalHeritage.ID = item.wid
      this.isDetailHeritageOpen = true;

    },
    openDialogDetail(singlestory) {
      this.detailModal.image = singlestory.cover_image
      this.detailModal.title = singlestory.title
      this.detailModal.shortDescription = singlestory.shortDescription
      this.detailModal.similarities = singlestory.tags
      this.detailModal.storyID = singlestory.id
      this.isDetailOpen = true;

    },
    swipe(direction) {
      this.swipeDirection = direction
    },
    waitFunction() {
      //this is a workaround for the map to load correctly since the leaflet component has a bug
      setTimeout(() => {
        this.$refs.map.mapObject.invalidateSize()
      }, 100)
    },
    retrivePositionMarkerPlace: async function (markerposition) {
      try {
        return this.getaxiosResponse(this.apiUrl + '/getGeoLocationInfo?lat=' + markerposition.lat + '&lon=' + markerposition.lng)
      } catch (error) {
        if (error.status === 400) {
          // Handle error.
        }
        // Handle error.
        else {
          console.log(error);
        }
      }
    },
    goBack: function () {
      window.history.go(-1);
    },
  },
  props: {
    marker: {
      type: Object,
      required: false
    },
    storyTitle: {
      type: String,
      required: false
    }
  }
}
</script>

<style scoped>
hr.dashedDarkGreen {
  border-top: 2px dashed black;
}

hr.dashedLightGreen {
  border-top: 2px dashed #81B9BF;
}

hr.solidDarkGreen {
  border-top: 2px solid black;
}

.labelConnections {
  font-size: 0.5rem;
}

.KGheritageImage {
  width: 40px;
  height: 40px;
  border-radius: 100px;
  border: 2px solid black
}

.squaresolid {
  width: 50px;
  height: 50px;
  aspect-ratio: 1.0;
  border-radius: 50px;
  border: 4px solid black;
}

.coverImageStyle img {
  border-radius: 50px;
}

.leaflet-container {
  background-color: rgba(97, 92, 92, 0.062);
}

.styleMapAddress {
  font-size: 0.8rem;
}

.maxwidth {
  width: 200px;
}

.detailStoryImg {
  width: 90%;
  margin-left: auto;
  margin-right: auto;
  height: auto;
  box-sizing: content-box;
}

.sliderCoverImg {
  width: 100%;
  height: auto;
  max-width: 200px;
  box-sizing: content-box;
}

.v-application p {
  margin-bottom: 0px;
}

.uppercase--text {
  text-transform: uppercase;
}

.breakWord {
  font-size: 65%;
  overflow-wrap: break-word;
  max-width: 40vh;
}

.squaresolid {
  border-radius: 5%;
  border: 2px solid black;
  min-width: 10vh;
  min-height: 10vh;
  word-wrap: break-word;
  background-color: #EEE;
}

.squaresolidHeritage {
  border-radius: 5%;
  border: 2px solid black;
  min-width: 10vh;
  min-height: 10vh;
  word-wrap: break-word;
  background-color: #b8e6bf;
}

.squaredotted {
  border-radius: 5%;
  border: 2px solid black;
  min-width: 20vh;
  min-height: 20vh;
  word-wrap: break-word;
  background-color: #EEE;
  border-style: dotted;
}

.circle {
  height: 5vh;
  width: 5vh;
  background-color: #555;
  border-radius: 50%;
}
</style>
